import axios from "axios";

axios.defaults.baseURL = "https://indextopipsapi.stage.bridgespecialty.com/api/";

export const SetAxiosDefauls = () => {
  axios.interceptors.request.use(onRequestFulfilled, onRequestRejected);
  axios.interceptors.response.use(onResponseFulfilled, onResponseRejected);
}
const onRequestFulfilled = async(config) => {
  let token = localStorage.getItem('auth-token');
  let userId = sessionStorage.getItem('userId');
  console.log("TOkeee", token)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (userId) {
    config.headers.userId = userId;
  }
  return Promise.resolve(config);
}

const onRequestRejected = (error) => {
  console.log("errorrr", error);
  return Promise.reject(error);
}

const onResponseFulfilled = (config) => {
  return Promise.resolve(config)
}

const onResponseRejected = (error) => {
  console.log("errorrr", error);
  return Promise.reject(error);
}
